import { render } from "./notice-5.vue?vue&type=template&id=7631069a&scoped=true"
import script from "./notice-5.vue?vue&type=script&lang=js"
export * from "./notice-5.vue?vue&type=script&lang=js"

import "./notice-5.vue?vue&type=style&index=0&id=7631069a&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7631069a"]])

export default __exports__